export default __webpack_public_path__ + "static/media/icon-flag-english.a3ee52e5.svg";